import { toYesplanDateTimeObject } from '../libs/dateTimeUtilities';

export default class YPTimesheetLogItemObject {
  constructor(logJSON) {
    const { description, timestamp, type, user } = logJSON;
    this.logText = description;
    this.timestamp = toYesplanDateTimeObject(timestamp);
    this.action = type;
    this.user = user;
  }

  getTimestamp() {
    return this.timestamp;
  }

  getLogText() {
    return this.logText;
  }

  getActionType() {
    return this.action || undefined;
  }

  getUser() {
    return this.user;
  }

  isAfterLogItem(logItem) {
    return this.timestamp.isAfter(logItem.getTimestamp());
  }

  isFinalStateLogItem() {
    return this.getActionType() === 'approve' || this.getActionType() === 'finalize';
  }
}
